module.exports = __webpack_public_path__ + "static/important-loans-a96c98f1cd4616161765d44d21a2a768.png";